var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "#FFD15A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7665 0.400884C12.0778 0.680669 12.0778 1.13609 11.7665 1.41588L4.67002 7.79388C4.36135 8.07131 3.86286 8.07131 3.55418 7.79388L0.23348 4.80941C-0.0778262 4.52962 -0.077827 4.0742 0.23348 3.79441L0.445837 3.60355C0.754505 3.32613 1.253 3.32613 1.56167 3.60355L3.55418 5.39434C3.86286 5.67174 4.36135 5.67174 4.67002 5.39434L10.4383 0.210021C10.7469 -0.0674029 11.2454 -0.0674029 11.5542 0.210021L11.7665 0.400884Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.306e15772cfbb057941dd24c9de0d163.svg";
export { ForwardRef as ReactComponent };